module.exports = __webpack_public_path__ + "img/logo-ml.4ebf810e.png";